const list = {
    or: 'lub',
    and: 'i',
    separator: ',',
};
export default Object.freeze(list);
